<template>
  <div class="catalog-layout">
  <div class="gap-12 px-big-gap lg:grid grid-cols-[300px,1fr] relative" :class="[{nofilter:nofilter}]">
    <div>
      <layout-category-sidebar v-if="filter.ITEMS && filter.ITEMS.length>0" class="sidebar" @goFilterCheck="goFilterCheck" @reset="reset" :elementCount="filter.elementCount">
      <slot slot="subcategory" name="subcategory"></slot>

      <ui-filter-selected @closeFieldsSelect="closeFieldsSelect" @closeFieldsCheckbox="closeFieldsCheckbox" :filters="filter.ITEMS"></ui-filter-selected>

    <template
        v-for="(item, key, index) in filter.ITEMS"
        :key="key"
        :name="item.NAME"
    >
<!--      <template v-if="item.DISPLAY_TYPE && (item.CODE=='DLINA' || item.CODE=='SHIRINA')">-->
      <template v-if="item.DISPLAY_TYPE && (item.CODE=='GABARITY' || item.CODE=='BASE_PRICE')">
        <ui-filter-select
            :key="idComponent"
            :label="item.NAME"
            :code="item.CODE"
            :id="item.ID"
            property="size"
            :options="optionsData( item.VALUES )"
            @filterItemChange="filterItemChange"
        ></ui-filter-select>
      </template>
      <template v-else-if="item.PROPERTY_TYPE==='L'">
        <ui-filter-checkbox
            :key="idComponent+1"
            :label="item.NAME"
            :code="item.CODE"
            :id="item.ID"
            :help="item.FILTER_HINT"
            property="time"
            :options="optionsData( item.VALUES )"
            @filterItemChange="filterItemChange"
        ></ui-filter-checkbox>

<!--        <ui-help-tooltip label="?" v-if="item.FILTER_HINT" :width="400">
          <span v-html="encodesHtml(item.FILTER_HINT)"></span>
        </ui-help-tooltip>-->
      </template>
    </template>
<!--
    <ui-filter-buttons label="Бюджет" property="budget" :options="[{value: 'До 10 000 Р', label: '15'}, {value: 'До 30 000 Р', label: '23'}, {value: 'До 50 000 Р', label: '21'}, {value: 'До 100 000 Р', label: '99'}]"></ui-filter-buttons>
-->

  </layout-category-sidebar>
    </div>
    <div>
      <quiz-banner
          v-if="paramsFilter.IBLOCK_ID && paramsFilter.IBLOCK_ID==='95'"
          class="mb-4"
          text="Нажмите, чтобы пройти опросник"
          caption="Займет не более 5 минут"
          link="/quiz/"
          title="Подберите матрас персонально"
          subtitle="Ответьте на несколько вопросов и наша система подберет идеальный матрас для вас всего за пару минут">
      </quiz-banner>
      <quiz-banner
          v-else-if="paramsFilter.IBLOCK_ID && paramsFilter.IBLOCK_ID==='97'"
          image="/images/quiz/quiz-banner-pillow.jpg"
          class="mb-4"
          text="Нажмите, чтобы пройти опросник"
          caption="Займет не более 5 минут"
          link="/quiz-pillows/"
          title="Подберите подушку персонально"
          subtitle="Ответьте на несколько вопросов и наша система подберет идеальную подушку для вас всего за пару минут">
      </quiz-banner>

      <layout-category-quick-sort :linkquickfilters='linkquickfilters' @sorted-event="sortedMethod" :sorted.sync="sorted" :sort-options="[{label: 'По возрастанию цены', value: 'priceasc'}, {label: 'По убыванию цены', value: 'pricedesc'}, {label: 'По полулярности', value: 'popdsc'}, {label: 'По рейтингу', value: 'ratingdesc'}]">
<!--        <a slot="link" href="http://localhost:8080/category?size=120x70">Детский матрас 120 x 70</a>
        <a slot="link" href="http://localhost:8080/category?size=130x70&time=1%20день">130x70 за 1 день</a>-->
        <!--  -->
      </layout-category-quick-sort>
      <template v-if="slotcategory">
          <slot name="categoryProducts"></slot>
        </template>
      <layout-category-products v-if="products">
          <layout-product-card
              v-for="(product, i) in products"
              :key="idComponent"
              :inShowroom="product.STORE"
              :product="product"
              :filter="filter"
              :value.sync="value"
              :updateSizeAll="true"
          >
          </layout-product-card>
        </layout-category-products>
    </div>
  </div>

      <slot name="pag"></slot>
      <layout-pagination :send="false" v-if="pagecount>1" :key="idComponent" :paramsFilter="paramsFilter" :pagenation="pagenation"></layout-pagination>


    <ui-in-cart-notification></ui-in-cart-notification>

    <quiz-widget v-if="paramsFilter.IBLOCK_ID && paramsFilter.IBLOCK_ID==='95'" text="Нажмите, чтобы пройти опросник" caption="Займет не более 5 минут" link="/quiz/" title="Подберите матрас персонально" subtitle="Ответьте на несколько вопросов и наша система подберет идеальный матрас для вас всего за пару минут"></quiz-widget>
    <quiz-widget v-else-if="paramsFilter.IBLOCK_ID && paramsFilter.IBLOCK_ID==='97'" text="Нажмите, чтобы пройти опросник" caption="Займет не более 5 минут" link="/quiz-pillows/" title="Подберите подушку персонально" subtitle="Ответьте на несколько вопросов и наша система подберет идеальную подушку для вас всего за пару минут"></quiz-widget>
    <!--    <quiz-modal-banner v-if="paramsFilter.IBLOCK_ID && paramsFilter.IBLOCK_ID==='95'" :timeout="5000" text="Нажмите, чтобы пройти опросник" caption="Займет не более 5 минут" link="/quiz/" title="Подберите матрас персонально" subtitle="Ответьте на несколько вопросов и наша система подберет идеальный матрас для вас всего за пару минут"></quiz-modal-banner>-->
  </div>
</template>

<script>
import vuescroll from 'vuescroll'
    export default {
        components: {
          vuescroll,
          'layout-category-filters': () => import('@/components/layout/category/layout-category-filters'),
          'ui-filter-selected': () => import('@/components/ui/filter/ui-filter-selected'),
          'ui-filter-select': () => import('@/components/ui/filter/ui-filter-select'),
          'ui-filter-checkbox': () => import('@/components/ui/filter/ui-filter-checkbox'),
          'ui-filter-buttons': () => import('@/components/ui/filter/ui-filter-buttons'),
          'layout-category-sidebar': () => import('@/components/layout/category/layout-category-sidebar'),
          'layout-category-quick-sort': () => import('@/components/layout/category/layout-category-quick-sort'),
          'layout-category-suggestions': () => import('@/components/layout/category/layout-category-suggestions'),
          'layout-category-products': () => import('@/components/layout/category/layout-category-products'),
          'layout-category-filter-list': () => import('@/components/layout/category/layout-category-filter-list'),
          'layout-product-card': () => import('@/components/layout/product/layout-product-card'),
          'layout-pagination': () => import('@/components/layout/layout-pagination'),
          'ui-button': () => import('@/components/ui/ui-button'),
          'icon-close': () => import('@/components/icon/icon-close'),
          'ui-in-cart-notification': () => import('@/components/ui/ui-in-cart-notification'),
          'layout-loader': () => import('@/components/layout/layout-loader'),
          'ui-help-tooltip': () => import('@/components/ui/ui-help-tooltip'),
          'quiz-widget': () => import('@/components/quiz/widget'),
          'quiz-modal-banner': () => import('@/components/quiz/modal-banner'),
          'quiz-banner': () => import('@/components/quiz/banner'),
        },
        props: {
          linkquickfilters: [],
          openedFilters: {
                type: Number,
                default() {
                    return 10
                }
            },
          titlepage: "",
          seoText: "",
          paramsFilter: {},
          request: {},
          pagenquery: {}
        },
        data() {
            return {
                isMobile: false,
                ops: {
                  vuescroll: {
                    sizeStrategy: 'number'
                  },
                  rail: {
                    keepShow: true,
                    specifyBorderRadius: '0px'
                  },
                  bar: {
                    onlyShowBarOnScroll: false,
                    background: 'var(--color)',
                    keepShow: false,
                    hoverStyle: true
                  }
                },
                elFilterCount: 0,
                idComponent: 0,
                loading: false,
                opened: false,
                filter: {},
                products: [],
                pagenation: {},
                filterHtml: undefined,
                page: 1,
                pagen: 1,
                scroll: true,
                scrollTop: 0,
                scrollUp: false,
                sorted: "priceasc",
                pagecount: 0,
                productcount: 0,
                noProduct: false,
                width: window.innerWidth,
                moreButton: false,
                slotcategory: true,
                nofilter: false,
                value: {
                  select:{},
                  checkbox:{}
                },
            }
        },
        methods:{
            sortedMethod (res){
              this.sorted=res;
              ///this.filterCheck('product', 'sorted');
            },
            removeSessionSize(code){
              this.$axios({
                url: '/ajax/remove-session-size.php',
                headers: {'Content-Type': 'application/json'},
                method: 'post',
                data: { code:code,iblock_id:this.paramsFilter.IBLOCK_ID  }
              }).then(response => {
                if (response.status == 200) {}
              }).catch(e => {
                console.log('Error: ' + e)
              })
            },
            filterItemChange(event) {
            var param = "";
            var paramFirst = "filter/";
            if( event.type=="select" ){
              if( this.value.select[event.id] && this.value.select[event.id]===event.control_id ){
                //this.closeFieldsSelect(event.id);
                //delete this.value.select[event.control_id];
              }else{
                this.value.select[event.id]=event.control_id;
              }
            }else if ( event.type=="checkbox" ){
                if( this.value.checkbox[event.control_id] ){
                  delete this.value.checkbox[event.control_id];
                }else{
                  this.value.checkbox[event.control_id]=true;
                }
            }

           // if( typeof event.target.value === "undefined" && typeof event.target.dataset.code !== "undefined"){
           //   this.removeSessionSize(event.target.dataset.code);
           // }


            Object.keys(this.value.select).forEach(key => {
              let prop = this.filter.ITEMS.find(props => props.ID === key);
              if(prop){
                let val = prop.VALUES.find(vals => vals.CONTROL_ID === this.value.select[key]);
                if(val) {
                  //URL_ID_NEWparam += prop.CODE.toLowerCase() + '-is-' + val.URL_ID + '/';
                  param += val.URL_ID_NEW + '/';
                }
              }
            });
            Object.keys(this.value.checkbox).forEach(key => {
              if( this.value.checkbox[key] ) {
                let prop = this.filter.ITEMS.find(props =>
                    props.VALUES.find(values =>
                        values.CONTROL_ID === key
                    )
                );
                if (prop) {
                  let val = prop.VALUES.find(valss => valss.CONTROL_ID === key);
                  //param += prop.CODE.toLowerCase() + '-is-' + val.URL_ID + '/';
                  param += val.URL_ID_NEW + '/';
                }
              }
            });
            if(param.length>0){
              param = paramFirst+param;//+"apply/";
            }else if(this.paramsFilter.SEF_RULE.length>0){
              //param = this.paramsFilter.SMART_FILTER_PATH;
              param = '';
            }
            this.request.param = param;
            this.$axios({
              url: '/ajax/filter-change.php',
              headers: {'Content-Type': 'application/json'},
              method: 'post',
              data: { request:this.request,paramsFilter:this.paramsFilter  }
            }).then(response => {
              if (response.status == 200) {
                this.filter = response.data.filter;
                if(response.data.filter && response.data.filter.ITEMS){
                  let obFilter = response.data.filter.ITEMS;
                  this.value.select={};
                  this.value.checkbox={};
                  obFilter.forEach((el) => {
                    if(el.VALUES && el.VALUES.length) {
                      el.VALUES.forEach((elV) => {
                        if (elV.CHECKED) {
                          if (el.CODE=='GABARITY') {
                            this.value.select[el.ID] = elV.CONTROL_ID
                          } else {
                            this.value.checkbox[elV.CONTROL_ID] = true
                          }
                        }
                      });
                    }
                  });
                }
              }
            }).catch(e => {
              console.log('Error: ' + e)
            })


          },
            filterCheck(ev, type) {
                this.loading = true;
                if(ev=="product" || ev=="reset"){
                    this.page=1;
                    this.slotcategory=false;
                }
                var param = "";
                var paramFirst = "filter/";

                if(ev!="reset" && this.value.select ){
                  Object.keys(this.value.select).forEach(key => {
                    let prop = this.filter.ITEMS.find(props => props.ID === key);
                    if(prop){
                      let val = prop.VALUES.find(vals => vals.CONTROL_ID === this.value.select[key]);
                      if(val) {
                        //URL_ID_NEWparam += prop.CODE.toLowerCase() + '-is-' + val.URL_ID + '/';
                        param += val.URL_ID_NEW + '/';
                      }
                    }
                  });
                }
                if(ev!="reset" && this.value.checkbox ){
                  Object.keys(this.value.checkbox).forEach(key => {
                    if( this.value.checkbox[key] ) {
                      let prop = this.filter.ITEMS.find(props =>
                          props.VALUES.find(values =>
                              values.CONTROL_ID === key
                          )
                      );
                      if (prop) {
                        let val = prop.VALUES.find(valss => valss.CONTROL_ID === key);
                        //param += prop.CODE.toLowerCase() + '-is-' + val.URL_ID + '/';
                        param += val.URL_ID_NEW + '/';
                      }
                    }
                  });
                }

                if(param.length>0){
                    param = paramFirst+param;//+"apply/";
                }else if(this.paramsFilter.SEF_RULE.length>0){
                    //param = this.paramsFilter.SMART_FILTER_PATH;
                    param = '';
                }
                //if(type=="closeFieldsSelect" || type=="closeFieldsCheckbox" || type=="updateProduct" || type=="remove" || type=="reset" || type=="filtercheck"){
                  this.page=1;
                  this.sorted="priceasc";
                //}
                ///if(this.page>1){
                ///  param = param+'page-'+this.pagen+'-'+this.page+'/';
                ///}
                ///if(this.sorted!="priceasc") {
                ///param = param + 'sort-' + this.sorted + '/';
                ///}
                this.request.param = param;
                window.history.pushState({"reload":param.length}, '', `${this.paramsFilter.SEF_RULE}${param}`);
                this.$axios({
                  url: '/ajax/category.php',
                  headers: {'Content-Type': 'application/json'},
                  method: 'post',
                  data: {
                    sort:this.sorted,
                    request:this.request,
                    paramsFilter:this.paramsFilter,
                    pagen:this.pagen,
                    page:(ev=='pagination') ? this.page : 1,
                    type: type
                  }
                }).then(response => {
                    if (response.status == 200) {
                      this.filter = response.data.filter;
                      //this.sorted = response.data.sort;
                      if(response.data.filter && response.data.filter.ITEMS){
                          let obFilter = response.data.filter.ITEMS;
                          this.value.select={};
                          this.value.checkbox={};
                          obFilter.forEach((el) => {
                            if(el.VALUES && el.VALUES.length) {
                              el.VALUES.forEach((elV) => {
                                if (elV.CHECKED) {
                                  if (el.CODE == "GABARITY") {
                                    this.value.select[el.ID] = elV.CONTROL_ID
                                  } else {
                                    this.value.checkbox[elV.CONTROL_ID] = true;
                                  }
                                }
                              });
                            }
                          });
                      }
                      //if(ev=="pagination") {
                      //  this.products = this.products.concat(response.data.section);
                      //}else{
                        this.products = response.data.section;
                      this.slotcategory = false;
                      //}

                      this.pagenation = response.data.pagenation;
                      this.pagecount = parseInt(response.data.pagenation.NavPageCount);
                      this.productcount = parseInt(response.data.pagenation.NavRecordCount);
                      this.filter.elementCount = this.productcount;
                      if(this.page>=parseInt(response.data.pagenation.NavPageCount)){
                          this.moreButton = false
                          this.pagecount=0;
                      }else{
                          this.moreButton = true
                      }
                      this.idComponent += 1;
                      this.loading = false;
                      if (this.page > 1) {
                        const arTitle = document.title.split(',')
                        document.title = arTitle[0] + ', страница № ' + this.page
                        let meta=document.getElementsByTagName("meta");
                        for (var i=0; i<meta.length; i++) {
                            if (meta[i].name.toLowerCase()=="description") {
                                const arStr = meta[i].content.split(',')
                                meta[i].content = arStr[0] + ', страница № ' + this.page
                            }
                        }
                        let header = document.getElementsByTagName('h1')[0]
                        let arHeader = header.innerText.split(',')
                        header.innerText = arHeader[0] + ', страница № ' + this.page
                      }

                    }
                }).catch(e => {
                    console.log('Error: ' + e)
                })

            },
            pagination: function(numPage) {
              this.page = numPage;
              this.filterCheck('pagination', 'pagination');
            },
            reset: function() {
                this.$el.querySelectorAll('.filters').checked=false;
                this.value.select={};
                this.value.checkbox={};
                this.opened=false;
                this.filterCheck('reset', 'reset');
            },
            updateWidth() {
                this.width = window.innerWidth;
            },
            scrolls(){
                let layoutCategoryPage = document.querySelector('.catalog-layout');
                layoutCategoryPage.scrollIntoView();
            },
            customLabel (option) {
                return `${option.VALUE}`
            },
            onRemove (option) {
                document.getElementById(option.CONTROL_ID).checked=false;
                this.filterCheck('product', 'remove');
            },
            async createdPullProduct(params){
              let created = params=="created";
              await this.$axios({
                url: '/ajax/category.php', headers: {'Content-Type': 'application/json'}, method: 'post',
                data: { created:created,
                  sort:this.sorted,
                  request:this.request,
                  paramsFilter:this.paramsFilter,
                  pagen:(this.pagenquery[1])?this.pagenquery[1]:'',
                  page:(this.pagenquery[2]) ? this.pagenquery[2] : "",
                  type:'created',
                }
              }).then(response => {
                if (response.status == 200) {
                  if(response.data.filter && response.data.filter.ITEMS.length > 0){
                    ///this.sorted = response.data.sort;
                    this.filter = response.data.filter;
                    let obFilter = response.data.filter.ITEMS;
                    this.value.select={};
                    this.value.checkbox={};
                    obFilter.forEach((el) => {
                      if(el.VALUES && el.VALUES.length) {
                        el.VALUES.forEach((elV) => {
                          if (elV.CHECKED) {
                            if (el.CODE == "GABARITY") {
                              this.value.select[el.ID] = elV.CONTROL_ID
                            } else {
                              this.value.checkbox[elV.CONTROL_ID] = true;
                            }
                          }
                        });
                      }
                    });
                    this.paramsFilter.SEF_RULE = response.data.filter.FILTER_URL;
                  }else{
                    this.nofilter=true;
                  }
                  this.products = response.data.section;
                  this.pagenation = response.data.pagenation;
                  this.pagen = parseInt(response.data.pagenation.NavNum);
                  this.productcount = parseInt(response.data.pagenation.NavRecordCount);
                  this.filter.elementCount = this.productcount;
                  //this.page++;
                  this.pagecount = parseInt(response.data.pagenation.NavPageCount);

                  if( this.productcount < 1 ){
                    this.noProduct = true;
                  }
                  //this.loading = false;
                }
              }).catch(e => {
                console.log('Error: ' + e)
              })
            },
            encodesHtml(text){
              return JSON.parse(text);
            },
            goFilterCheck(){
              this.opened=false;
              this.filterCheck('product', 'filtercheck');
            },
            closeFieldsCheckbox(control_id){
              delete this.value.checkbox[control_id];
              this.filterCheck('product', 'closeFieldsCheckbox');
            },
            closeFieldsSelect(key){
              delete this.value.select[key];
              let prop = this.filter.ITEMS.find(props => props.ID === key);
              this.removeSessionSize(prop.CODE);
              this.filterCheck('product', 'closeFieldsSelect');
            },
            nameProperty(control_id){
              let prop = this.filter.ITEMS.find(props =>
                  props.VALUES.find(values =>
                      values.CONTROL_ID === control_id
                  )
              );
              return prop.NAME;
            },
            valueProperty(control_id){
              let valFileds = "";
              let prop = this.filter.ITEMS.find(props =>
                  props.VALUES.find(values =>
                      values.CONTROL_ID === control_id
                  )
              );
              if (prop) {
                let val = prop.VALUES.find(valss => valss.CONTROL_ID === control_id);
                valFileds = val.VALUE;
              }
              return valFileds;
            },
            namePropertySelect(id){
              let propName = this.filter.ITEMS.find(props => props.ID===id).NAME;
              return propName;
            },
            optionsData( values ){
              let res = [];
              if( values.length ){
                values.forEach((el) => {
                  let op = {}
                  op.value=el.VALUE;
                  //op.label='В наличии';
                  op.disabled = !!(el.DISABLED);
                  op.selected = !!(el.CHECKED);
                  op.count = el.ELEMENT_COUNT;
                  op.url_id = el.URL_ID_NEW;
                  op.control_id = el.CONTROL_ID;
                  res.push(op);
                });
              }
              return res;
            },
            showVisible() {
              var imgs = document.getElementsByTagName('img');
              for (var i = 0; i < imgs.length; i++) {
                var img = imgs[i];
                var realsrc = img.getAttribute('realsrc');
                if (!realsrc) continue;
                if (this.isVisible(img)) {
                  this.functionShowImageFlag = true;
                  img.src = realsrc;
                  img.setAttribute('realsrc', '');
                  img.classList.remove('load');
                }
              }
            }
        },
        created () {

          let sort = location.href.match(/sort-([a-zA-Z]+)\//);
          if(sort && sort[1]){
            this.sorted = sort[1];
          }
          this.createdPullProduct("created");

          //let delayedHandler = lodash.debounce(this.autoPagination, 100);
          //window.addEventListener('scroll', delayedHandler);
          window.addEventListener('resize', this.updateWidth);
          window.addEventListener('popstate', event => {
            document.location.reload();

              if(event!=null && event.state!=null && event.state.reload!=null){
                //this.filterCheck('product');
                //history.go (0);
                //document.location.reload();
              }
            });
          this.$on('updateOpened', (eventOpened) => {
            this.opened=eventOpened;
          });
          this.$bus.$on('pagination', (numPage) => {
            this.pagination(numPage);
          });
          this.$bus.$on('updateSizeOffersProduct', (offer) => {

            /*
            if( offer.PROPERTIES.DLINA ) {
              let dlina = this.filter.ITEMS.find(props => props.ID === offer.PROPERTIES.DLINA.ID);
              if( dlina && offer.PROPERTIES.DLINA.VALUE ) {
                let dlinaValue = dlina.VALUES.find(values => values.VALUE === offer.PROPERTIES.DLINA.VALUE);
                if( dlinaValue ) {
                  this.value.select[dlina.ID] = dlinaValue.CONTROL_ID;
                }
              }
            }
            if( offer.PROPERTIES.SHIRINA ) {
              let shirina = this.filter.ITEMS.find(props => props.ID === offer.PROPERTIES.SHIRINA.ID);
              if( shirina && offer.PROPERTIES.SHIRINA.VALUE ) {
                let shirinaValue = shirina.VALUES.find(values => values.VALUE === offer.PROPERTIES.SHIRINA.VALUE);
                if( shirinaValue ) {
                  this.value.select[shirina.ID] = shirinaValue.CONTROL_ID;
                }
              }
            }
            if( offer.PROPERTIES.RAZMER ) {
              let razmer = this.filter.ITEMS.find(props => props.ID === offer.PROPERTIES.RAZMER.ID);
              if( razmer && offer.PROPERTIES.RAZMER.VALUE ) {
                let razmerValue = razmer.VALUES.find(values => values.VALUE === offer.PROPERTIES.RAZMER.VALUE);
                if( razmerValue ) {
                  this.value.select[razmer.ID] = razmerValue.CONTROL_ID;
                }
              }
            }
            if( offer.PROPERTIES.GABARITY ) {
              let gabarity = this.filter.ITEMS.find(props => props.ID === offer.PROPERTIES.GABARITY.ID);
              if( gabarity && offer.PROPERTIES.GABARITY.VALUE ) {
                let gabarityValue = gabarity.VALUES.find(values => values.VALUE === offer.PROPERTIES.GABARITY.VALUE);
                if( gabarityValue ) {
                  this.value.select[gabarity.ID] = gabarityValue.CONTROL_ID;
                }
              }
            }
            if( offer.PROPERTIES.DIAMETR ) {
              let diametr = this.filter.ITEMS.find(props => props.ID === offer.PROPERTIES.DIAMETR.ID);
              if( diametr && offer.PROPERTIES.DIAMETR.VALUE ) {
                let diametrValue = diametr.VALUES.find(values => values.VALUE === offer.PROPERTIES.DIAMETR.VALUE);
                if( diametrValue ) {
                  this.value.select[diametr.ID] = diametrValue.CONTROL_ID;
                }
              }
            }
            if( offer.PROPERTIES.MATERIAL_TYPE ) {
              let materialType = this.filter.ITEMS.find(props => props.ID === offer.PROPERTIES.MATERIAL_TYPE.ID);
              if( materialType && offer.PROPERTIES.MATERIAL_TYPE.VALUE ) {
                let materialTypeValue = materialType.VALUES.find(values => values.VALUE === offer.PROPERTIES.MATERIAL_TYPE.VALUE);
                if( materialTypeValue ) {
                  this.value.select[materialType.ID] = materialTypeValue.CONTROL_ID;
                }
              }
            }
            this.filterCheck('product');
            */

          });
          this.$bus.$on('updateProduct', () => {
            this.filterCheck('product', 'updateProduct');
          });
          window.addEventListener('scroll', () => {
            //this.showVisible();
          });
          window.scrollTo(0, 10);
        },
        mounted(){
          //if(this.paramsFilter.SMART_FILTER_PATH) return;
          //document.querySelector('.doH1').remove();
        },
        beforeMount() {
          this.isMobile = window.innerWidth < 768
        }
    }
</script>

<style lang="scss">
  .countsEl{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: var(--color);
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    padding: 0 6px;
    position: relative;
    font-size: 12px;
  }
  .selectSizeBlock{
    display: inline-block;
    width: 45%;
  }
  .selectSizeBlock:nth-child(odd){
    margin-left: 10px;
  }
  .button-wrapper-block {
    display: flex;
    gap: 10px;
    overflow: hidden;
    .items{
      display: grid;
      grid-auto-columns: max-content;
      grid-auto-flow: column;
      gap: 10px;
    }
    .selectedFilds {
      display: block !important;
      cursor: default !important;
      padding-bottom: 1px !important;

      .propName {
        position: relative;
        top: -5px;
        left: 2px;
        margin-right: 25px;
      }

      .propValue {
        padding-top: 0px;
        position: relative;
        top: -5px;
        margin-right: 25px;
        white-space: nowrap;
      }

      .propClose {
        position: absolute;
        top: 5px;
        right: 15px;
        cursor: pointer;
      }
    }
    .button {
      position: relative;
      border-radius: 100px;
      padding: 0.7em 1.2em;
      display: inline-flex;
      border: 1px solid rgba(61, 74, 108, 0.3);
      cursor: pointer;
      transition: 0.3s;
      &.bg {
        background: var(--light);
        border-color: transparent;
      }
      &.transparent {
        border-color: transparent;
        &:hover {
          background: var(--light);
        }
      }
      &:not(.transparent) {
        &:hover {
          background: var(--color);
          color: #fff;
        }
      }
    }
  }
  .hidden-filters{
    label.disabled{
      text-decoration: line-through;
    }
  }
  @media screen and (max-width: 767px) {
    .button-wrapper-block {
      overflow-x: scroll;
      .items {
        padding-top: 20px;
        padding-bottom: 30px;
      }
    }
  }
  .grid-cols-\[300px\2c 1fr\].nofilter {
    grid-template-columns: 1fr !important;
  }
</style>
